import getPayeService from '../../../api/envService'
import { FONCTION_ENDPOINT, FONCTION_TAGS_ENDPOINT } from '../../../api/endpoints'
import { setLoader } from '../loader-action'
import { SET_FONCTIONS, SET_TAGS_FONCTIONS } from '../../reducers/fonction/fonction-reducer'
import { getParametres } from './parametre-action'
import { getVariableClients } from './variable-client-action'
import { getVariableContextes } from './variable-contexte-action'
import { getThemes } from '../theme-action'

export const setFonctions = models => {
  return { type: SET_FONCTIONS, value: models }
}

export const setTagsFonctions = models => {
  return { type: SET_TAGS_FONCTIONS, value: models }
}

export const getFonctions = () => dispatch =>
  Promise.resolve()
    .then(() => dispatch(setLoader(true)))
    .then(() => getPayeService().get(FONCTION_ENDPOINT))
    .then(models => dispatch(setFonctions(models)))
    .finally(() => dispatch(setLoader()))

export const getTags = () => dispatch =>
  Promise.resolve()
    .then(() => dispatch(setLoader(true)))
    .then(() => getPayeService().get(FONCTION_TAGS_ENDPOINT))
    .then(models => dispatch(setTagsFonctions(models)))
    .finally(() => dispatch(setLoader()))

export const createFonction = fonction => dispatch =>
  Promise.resolve()
    .then(() => getPayeService().post(FONCTION_ENDPOINT, fonction))
    .then(() => dispatch(getFonctions()))
    .catch(e => {
      console.log(e)
    })

export const updateFonction = fonction => dispatch =>
  Promise.resolve()
    .then(() => getPayeService().put(FONCTION_ENDPOINT, fonction))
    .then(() => dispatch(getFonctions()))
    .catch(e => {
      console.log(e)
    })

export const initFonctionsConfiguration = () => dispatch =>
  Promise.resolve()
    .then(() => dispatch(setLoader(true)))
    .then(() => dispatch(getFonctions()))
    .then(() => dispatch(getParametres()))
    .then(() => dispatch(getVariableClients()))
    .then(() => dispatch(getVariableContextes()))
    .then(() => dispatch(getThemes(true)))
    .finally(() => dispatch(setLoader(false)))
